import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import JoinWithUs from "../../Home/JoinWithUs";

import HeroLending from "./HeroLending";
import QuickInsightLending from "./QuickInsightLending";
import UnleashLending from "./UnleashLending";
import FeaturesLending from "./FeaturesLending";
import GetScriptLending from "./GetScriptLending";
import LaunchPlatformBanner from "./LaunchPlatformBanner";
import WhyChooseLending from "./WhyChooseLending";

function DeFiLendingAndBorrowing() {
  return (
    <div id="smooth-content">
      <Header />
      <HeroLending />
      <QuickInsightLending />
      <UnleashLending />
      <FeaturesLending />
      <GetScriptLending />
      <LaunchPlatformBanner />

      <WhyChooseLending />
      <Footer />
    </div>
  );
}

export default DeFiLendingAndBorrowing;
